import l10n from "diy/util/l10n";

import AlertWarningIcon from "material-ui/svg-icons/alert/warning";

import Type from "../definitions/Type";
import {NotificationConfig} from "../definitions/Config";

let translations = new Map<string, string>()
    .set("upgrade", l10n("upgradeBrowser.upgrade"))
    .set("switch", l10n("upgradeBrowser.switch"))
    .set("ie.text", l10n("upgradeBrowser.ie.text"))
    .set("ie.href", l10n("upgradeBrowser.ie.href"))
    .set("firefox.text", l10n("upgradeBrowser.firefox.text"))
    .set("firefox.href", l10n("upgradeBrowser.firefox.href"));

export type BrowserUpgradePayload = {
    browserType?: string;
    msgType?: string;
};

export default {
    type: Type.BROWSER_UPGRADE,
    testId: "browser-upgrade",
    trackingId: "BrowserUpgradeNotification",

    icon: AlertWarningIcon,

    cardOptions: {
        closable: false
    },

    onFactory: (notificationConfig: NotificationConfig) => {
        let msgType = notificationConfig.payload.msgType;
        let browserType = notificationConfig.payload.browserType;

        let message = translations.get(msgType);
        let browserButtonText = translations.get(browserType + ".text");
        let browserButtonLink = translations.get(browserType + ".href");

        notificationConfig.content = message;
        notificationConfig.mainAction = {
            testId: "do-upgrade",
            label: browserButtonText,
            onClick: () => {
                window.open(browserButtonLink, '_blank');
            }
        };
        return notificationConfig;
    }

} as NotificationConfig;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/types/BrowserUpgrade.ts
 **/